(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("googleSearchService", GoogleSearchService);
    GoogleSearchService.$inject = ['$q', 'googleMaps', 'registrationApi'];

    function GoogleSearchService($q, googleMaps, registrationApi) {
        var self = this;

        // Delay the google autocomplete request to at least (minInterval) of milliseconds
        // This is to reduce the number of requests and save quota
        var lastReq = 0;
        var oldResults = [];
        var minInterval = 500; // ms
        var timeoutPromise;

        // for autocompletion of addresses
        self.getAddress = function (searchTerm) {
            var defer = $q.defer();

            var currentReq = Date.now();
            var interval = currentReq - lastReq;

            var requestLocation = function (defer) {
                lastReq = currentReq;
                googleMaps.locationAutocomplete(searchTerm).then(function (results) {
                    oldResults = results;
                    defer.resolve(oldResults);
                });
            };

            if (interval > minInterval) {
                requestLocation(defer);
            } else {
                $timeout.cancel(timeoutPromise);

                timeoutPromise = $timeout(function () {
                    requestLocation(defer);
                }, minInterval);

            }

            return defer.promise;
        }

        //for searching places
        self.locationSearch = function (searchTerm) {
            var defer = $q.defer();

            registrationApi.ServerAndGooglePlaceBatchSearchWithPriorityToServer(searchTerm).then(function (result) {
                defer.resolve(result);
            });

            return defer.promise;
        }
    }
})();